import { c as _c } from "react-compiler-runtime";
import React from "react";
import { Text } from "react-aria-components";
import { useFieldErrorContext } from "../context.js";
import { FieldError } from "./FieldError.js";
import { base } from "./InputSubtext.css.js";
import { jsx as _jsx } from "react/jsx-runtime";
const BaseInputSubtext = (t0, ref) => {
  const $ = _c(8);
  let props;
  let text;
  if ($[0] !== t0) {
    ({
      text,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = text;
  } else {
    props = $[1];
    text = $[2];
  }
  const validation = useFieldErrorContext();
  if (validation?.isInvalid === true) {
    let t1;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = /*#__PURE__*/_jsx(FieldError, {});
      $[3] = t1;
    } else {
      t1 = $[3];
    }
    return t1;
  }
  if (text == null) {
    return null;
  }
  let t1;
  if ($[4] !== props || $[5] !== ref || $[6] !== text) {
    t1 = /*#__PURE__*/_jsx(Text, {
      slot: "description",
      className: base,
      ref: ref,
      ...props,
      children: text
    });
    $[4] = props;
    $[5] = ref;
    $[6] = text;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  return t1;
};
export const InputSubtext = /*#__PURE__*/React.forwardRef(BaseInputSubtext);
//# sourceMappingURL=InputSubtext.js.map